import moment from 'moment';
import DynamicAPI from '../../shared/axios';
import { luftGet } from '../../shared/http';
import {
  createActionString,
  createAsyncCreators,
  createAsyncRequestActions,
} from '../../utils/redux-boilerplate-creators';
import { USER_TYPES } from '../Admin/shared/static-options';

// ===========================
// Enums
// ===========================
export const orderByTypes = {
  NO_ORDER: 0,
  ASCENDING: 1,
  DESCENDING: 2,
};

// ===========================
// Actions
// ===========================
const GET_RECEIPTS = createAsyncRequestActions('receipts', 'GET_RECEIPTS');
const GET_RECEIPTS_BIG_NUMBERS = createAsyncRequestActions('receipts', 'GET_RECEIPTS_BIG_NUMBERS');

const UPDATE_SELECTED_PERIOD = createActionString('receipts', 'UPDATE_SELECTED_PERIOD');

// ===========================
// Action Creators
// ===========================
const getReceiptsCreators = createAsyncCreators(GET_RECEIPTS);
const getReceiptsBigNumbersCreators = createAsyncCreators(GET_RECEIPTS_BIG_NUMBERS);

export function updateSelectedPeriod(newPeriod) {
  return {
    type: UPDATE_SELECTED_PERIOD,
    payload: {
      newPeriod,
    },
  };
}

// ===========================
// Initial State
// ===========================
const initialState = {
  receipts: {
    isFetching: false,
    error: '',
    data: [],
    totalItems: null,
    order: orderByTypes.NO_ORDER,
  },
  bigNumbers: {
    isFetching: false,
    error: '',
    data: [],
  },
  selectedPeriod: 3,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_RECEIPTS.start: {
      return {
        ...state,
        receipts: {
          ...state.receipts,
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_RECEIPTS.finish: {
      if (action.error) {
        return {
          ...state,
          receipts: {
            ...state.receipts,
            isFetching: false,
            error: action.payload,
          },
        };
      }

      return {
        ...state,
        receipts: {
          ...state.receipts,
          isFetching: false,
          data: action.payload,
          totalItems: action.meta.totalItems,
          order: action.meta.order,
        },
      };
    }

    case GET_RECEIPTS_BIG_NUMBERS.start: {
      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_RECEIPTS_BIG_NUMBERS.finish: {
      if (action.error) {
        return {
          ...state,
          bigNumbers: {
            ...state.bigNumbers,
            isFetching: false,
            error: action.payload,
          },
        };
      }

      return {
        ...state,
        bigNumbers: {
          ...state.bigNumbers,
          isFetching: false,
          data: action.payload,
        },
      };
    }

    case UPDATE_SELECTED_PERIOD: {
      return {
        ...state,
        selectedPeriod: action.payload.newPeriod,
      };
    }

    default: {
      return state;
    }
  }
}

export function getReceipts(page, amount, searchQuery, orderBy = orderByTypes.NO_ORDER) {
  return async function (dispatch, getState) {
    dispatch(getReceiptsCreators.start());

    const { selectedPeriod } = getState().receipts;
    const finalPeriod = moment().format('YYYY-MM-DD');
    const initialPeriod = moment().subtract(selectedPeriod, 'month').format('YYYY-MM-DD');
    const {
      activeCompanyId,
      userType,
    } = getState().auth;

    try {
      const params = {
        companyId: userType === USER_TYPES.CUSTOMER_SERVICE_USER ? activeCompanyId : null,
        initialPeriod,
        finalPeriod,
        searchQuery: searchQuery || '',
        page,
        amount,
        orderBy,
      };

      const http = new DynamicAPI();
      const response = await http.get('/Financial/Receipts', params);

      dispatch(getReceiptsCreators.finish(response.data, false, {
        totalItems: response.data.totalItems,
        order: orderBy,
      }));
    } catch (error) {
      dispatch(getReceiptsCreators.finish(error.message, true));
    }
  };
}

export function getReceiptsBigNumbers(searchQuery = '') {
  return async function (dispatch, getState) {
    dispatch(getReceiptsBigNumbersCreators.start());

    const { selectedPeriod } = getState().receipts;
    const finalPeriod = moment().format('YYYY-MM-DD');
    const initialPeriod = moment().subtract(selectedPeriod, 'month').format('YYYY-MM-DD');

    const {
      activeCompanyId,
      userType,
    } = getState().auth;

    try {
      const params = {
        companyId: userType === USER_TYPES.CUSTOMER_SERVICE_USER ? activeCompanyId : null,
        initialPeriod,
        finalPeriod,
        searchQuery,
      };

      const response = await luftGet('/Financial/ReceiptsBigNumbers', params);

      dispatch(getReceiptsBigNumbersCreators.finish(response.data));
    } catch (error) {
      dispatch(getReceiptsBigNumbersCreators.finish(error.message, true));
    }
  };
}
